<template>
  <div>
    Waiting
  </div>
</template>
<script setup>
import {onMounted} from "vue";
import OAuthService from "@/utilities/services/OAuthService";

onMounted(async ()=> {
  const oAuthService = new OAuthService(); //TODO configure correctly  
  try {
    await oAuthService.refreshTokensSilently();
  }
  catch (e) {
    console.error(e);
    return;
  }
})

</script>
